<template>
  <page-section :content="content.sections.support" />
  <page-section :content="content.sections.support2" />
</template>

<script setup>
import content from "../content.js";
import PageSection from "./../components/section/Section.vue";
</script>
